<template>
  <div class="header-main">
    <div class="header-main__emoji">{{ current.emoji }}</div>
    <div class="header-main__copy">
      <div class="header-main__title">
        {{ current.title }}, {{ userInfo.name }} <i class="icon-sparkling-2-fill t-iconfont"></i>
      </div>
      <div class="header-main__desc">{{ current.desc }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import utils from '@/utils'

defineOptions({
  name: 'HeaderMain'
})

defineProps({
  userName: {
    type: String,
    default: '--'
  }
})

const userInfo = ref({
  avatar:
    utils.xbbLocalStorageGet('avatar') === 'undefined' ? '' : utils.xbbLocalStorageGet('avatar'),
  name:
    utils.xbbLocalStorageGet('userName') === 'undefined' ? '' : utils.xbbLocalStorageGet('userName')
})

const timeEnum = {
  morning: {
    emoji: '☀️',
    title: '上午好',
    desc: '没有敲不开的门，只有不够努力的脚，加油 💪🏻'
  },
  afternoon: {
    emoji: '☕️',
    title: '下午好',
    desc: '打起精神乘胜追击，助你多多赢单 ~'
  },
  evening: {
    emoji: '🌖',
    title: '晚上好',
    desc: '战绩已存档。今日的努力，是明天的伏笔。'
  }
}

const current = computed(() => {
  const hour = new Date().getHours()
  if (hour >= 6 && hour < 12) return timeEnum.morning
  if (hour >= 12 && hour < 18) return timeEnum.afternoon
  return timeEnum.evening
})
</script>

<style lang="scss" scoped>
.header-main {
  display: flex;

  .header-main__emoji {
    flex: 0 0 auto;
    width: 34px;
    margin-right: 12px;
    font-size: 34px;
    line-height: 34px;
  }

  .header-main__copy {
    flex: 1;
    display: flex;
    flex-direction: column;

    .header-main__title {
      font-size: 24px;
      font-weight: 600;
      line-height: 34px;
      color: #323233;
      margin-bottom: 4px;
      display: flex;
      align-items: center;

      i {
        margin-left: 8px;
        background: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        margin-right: 8px;
      }
    }

    .header-main__desc {
      font-size: 13px;
      line-height: 18px;
      color: #646566;
    }
  }
}
</style>
